import { showNotification } from '@mantine/notifications'
import type {
  VisitWithRelations,
  Visit,
  CreateVisitWithAttendees,
  UpdateVisit,
  BookSurveyVisitAuthenticated,
} from '@markku/types'
import { createCrudHooks } from './base'
import { trpc } from '../trpc'

const crudHooks = createCrudHooks<
  VisitWithRelations,
  Visit,
  CreateVisitWithAttendees,
  UpdateVisit
>('visit')

export const visitHooks = {
  ...crudHooks,

  useBookSurveyVisit: () => {
    return trpc.visit.bookSurveyVisitAuthenticated.useMutation({
      onSuccess: () => {
        showNotification({
          title: 'Varaus onnistui',
          message: 'Kartoituskäynti on varattu onnistuneesti',
          color: 'green',
        })
      },
      onError: (error) => {
        showNotification({
          title: 'Virhe varauksessa',
          message: error.message || 'Kartoituskäynnin varaus epäonnistui',
          color: 'red',
        })
      },
    })
  },

  useGetAvailableTimeSlots: () => {
    return trpc.visit.getAvailableTimeSlots.useQuery({})
  },
}

export type BookSurveyVisitInput = BookSurveyVisitAuthenticated
